export default __webpack_public_path__ + "static/media/seat.84c59290.svg";